<div class="flex flex-col items-center h-full bg-gray-100 px-4 py-6 relative">
    <!-- Logo Matwins grand -->
    <div class="mt-4 mb-2">
        <img [src]="logoUrl()" alt="Logo" class="w-60 h-40 object-contain">
    </div>

    <!-- Bienvenue -->
    <p class="text-blue-400 text-lg mb-8">{{ 'vues.ipad.welcome' | translate }}</p>

    <!-- Boutons Entrer / Sortir -->
    <div class="flex justify-center gap-48 mb-10">

        <!-- Entrer -->
        <div class="flex flex-col items-center cursor-pointer" (click)="navigateToCheckin()">
            <div class="w-44 h-44 rounded-full overflow-hidden shadow-lg bg-white flex items-center justify-center">
                <img src="/assets/images/ipad/signin.jpg" alt="Entrer" class="w-full h-full object-cover">
            </div>
            <h2 class="text-2xl font-bold text-gray-800 mt-1">{{ 'vues.ipad.enter.label' | translate }}</h2>
            <p class="text-sm text-gray-500">{{ 'vues.ipad.enter.description' | translate }}</p>
        </div>

        <!-- Sortir -->
        <div class="flex flex-col items-center cursor-pointer" (click)="navigateToCheckout()">
            <div class="w-44 h-44 rounded-full overflow-hidden shadow-lg bg-white flex items-center justify-center">
                <img src="/assets/images/ipad/signout.jpg" alt="Sortir" class="w-full h-full object-cover">
            </div>
            <h2 class="text-2xl font-bold text-gray-800 mt-1">{{ 'vues.ipad.exit.label' | translate }}</h2>
            <p class="text-sm text-gray-500">{{ 'vues.ipad.exit.description' | translate }}</p>
        </div>

    </div>

    <!-- QR Code -->
    <div class="mb-8">
        <!-- <img src="/assets/images/qrcode-placeholder.png" alt="QR Code" class="w-32 h-32 object-contain"> -->

        <div
            id="qrCodeHomeContainer"
            class="qrCodeHomeContainer qr-preview"></div>
    </div>


    <!-- Footer fixé en bas -->
    <div class="fixed bottom-0 left-0 right-0 flex justify-between items-center px-4 py-3 bg-gray-100"> <!-- Générer Code QR employé -->
        @if (showEmployeeQrGenerator()) {
        <button (click)="onGenerateEmployeeQR()" class="flex items-center gap-2 text-gray-600 hover:text-gray-800">
            <i class="fas fa-user-friends"></i>
            <span class="text-sm">{{ 'vues.ipad.generate.qr-employee' | translate }}</span>
        </button>
        }

        <!-- Alerte d'évacuation : visible quand le site a activé la fonctionnalité -->
        @if (showFireAlert()) {
        <button (click)="onAlert()" [disabled]="isAlerting()" class="flex items-center gap-2 text-red-600 hover:text-red-800 disabled:opacity-50">
            <i class="fa-solid fa-person-running fa-2x"></i>
            <span class="text-sm">{{ 'vues.ipad.visits.alert' | translate }}</span>
        </button>
        }

        <!-- Employés uniquement -->
        <button (click)="onEmployeesOnly()" class="flex items-center gap-2 text-gray-600 hover:text-gray-800">
            <i class="fas fa-user-friends"></i>
            <span class="text-sm">{{ 'vues.ipad.employees.only' | translate }}</span>
        </button>
    </div>

</div>